<template>
    <div class="watermark"></div>
</template>

<script>
export default {
    name: "watermark"
}
</script>

<style scoped lang="scss">
.watermark{position: fixed;width:100%;height:100%;pointer-events: none;
    z-index: 1000;background: url("../../assets/img/water.png");background-size: 100% auto;left:0;top:0;}
</style>